import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./App.css"; // Import your CSS file for custom modal styles
import PanModal from "./updateworkspace";
import CreateWorkspaceModal from "./CreateWorkspace";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GstinModel from "./GstinModel";
import { Link, useNavigate } from "react-router-dom";
import BaModal from "./BaModel";
import DaModal from "./DaModal";
import StakeholdersModal from "./StakeHolderModel";
import WorkspaceModal from "./Agency_Map";
import BoxFolderModal from "./BoxfolderModel";
import Agreports from "./Ag_Reports";
import PopupModal from "./PopupModel";
import { PanoramaSharp } from "@mui/icons-material";

Modal.setAppElement("#root");

const ReportTable = () => {
  const [rowData, setRowData] = useState([]);
  const [agencyNameMap, setAgencyNameMap] = useState({});
  const [isPanModalOpen, setIsPanModalOpen] = useState(false);
  const [panCount, setPanCount] = useState(0);
  const [panCounts, setPanCounts] = useState({});
  const [existingBoxFolderId, setBoxfolderid] = useState("")
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(null);
  const [workspaceName, setWorkspaceName] = useState(null)
  const [isDaModalOpen, setIsDaModalOpen] = useState(false); // State for DA Modal
  const [isBaModalOpen, setIsBaModalOpen] = useState(false); // State for BA Modal
  const [selectedDaValue, setSelectedDaValue] = useState(null);
  const [selectedBaValue, setSelectedBaValue] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false); // Renamed here
  const [boxFolderId, setBoxFolderId] = useState('');
  const [token, setToken] = useState(null);
  const filteredData = rowData.filter(row => row.hotel === true);



  const nav = useNavigate();


  const [columnDefs, setColumnDefs] = useState([
    // {
    //   headerName: "Workspace ID",
    //   field: "workspace_id",
    //   filter: true,
    //   width: "400",
    //   enableRowGroup: true
    // },
    {
      headerName: "Workspace Name",
      field: "workspace_name",
      filter: true,
      width: "400",
      enableRowGroup: true
    },
    {
      headerName: "Entity Type",
      field: "entity_type",
      filter: true,
      width: "200",
    },
    {
      headerName: 'FY 23-24',
      enableRowGroup: true,
      filter: true,
      children: [
        ...['fy23_followup', 'fy23_booking', 'fy23_expense', 'fy23_2b'].map(field => ({
          field,
          filter: true,
          enableRowGroup: true,
          columnGroupShow: field === 'fy23_followup' ? null : 'open',
          headerName: field.charAt(5).toUpperCase() + field.slice(6),
          cellRenderer: params => (
            <input
              type="checkbox"
              checked={params.value === 'YES'}
              onChange={e => handle23CheckboxChange(params, field, e.target.checked)}
            />
          ),
          editable: false
        }))
      ]
    },
    {
      headerName: 'FY 24-25',
      enableRowGroup: true,
      filter: true,
      children: [
        ...['fy24_followup', 'fy24_booking', 'fy24_expense', 'fy24_2b'].map(field => ({
          field,
          filter: true,
          enableRowGroup: true,
          columnGroupShow: field === 'fy24_followup' ? null : 'open',
          headerName: field.charAt(5).toUpperCase() + field.slice(6),
          cellRenderer: params => (
            <input
              type="checkbox"
              checked={params.value === 'YES'}
              onChange={e => handle24CheckboxChange(params, field, e.target.checked)}
            />
          ),
          editable: false
        }))
      ]
    },
    { field: 'priority', headerName: 'Priority', editable: true, filter: true, enableRowGroup: true, },
    { field: 'agency_name', headerName: 'Agency Name', cellClass: "clickable-cell", enableRowGroup: true, },
    {
      headerName: "PAN Count",
      field: "pan_count",
      cellClass: "clickable-cell",
      enableRowGroup: true
    },
    {
      headerName: "GSTIN Count",  // New column for GSTIN count
      field: "gstin_count",
      cellClass: "clickable-cell",
      filter: true,
      cellClass: "clickable-cell",
      enableRowGroup: true,
      width: "200"
    },
    { field: 'commercials', headerName: 'Commercials', editable: true, filter: true, enableRowGroup: true, },
    {
      headerName: "Is Active",
      field: "is_active",
      enableRowGroup: true,
      cellRendererFramework: (params) => {
        // Check if the value is present
        const isActive = params.value !== undefined && params.value !== null ? params.value : false;

        return (
          <input
            type="checkbox"
            checked={isActive}
            readOnly // Mark checkbox as readonly to avoid toggling
          />
        );
      },
      valueGetter: (params) => {
        // Return the actual is_active value for grouped rows
        if (params.node.group) {
          return null; // Set null or false for group headers if needed
        }
        return params.data ? params.data.is_active : false;
      }
    },
  
    // {
    //   headerName: "Workspace Box ID", // New column for workspace_box_id
    //   field: "workspace_box_id",
    //   filter: true,
    //   width: "300",
    //   cellClass: "clickable-cell",
    //   enableRowGroup: true
    // },
    // {
    //   headerName: "box_folder_id",
    //   field: "box_folder_id",
    //   filter: true,
    //   width: "300",
    //   cellClass: "clickable-cell",
    //   enableRowGroup: true
    // },
    {
      headerName: "Reports",
      field: "reports",
      cellClass: "clickable-cell",
      filter: true,
      width: "200",
      valueGetter: (params) => {
        // Add null/undefined check for params.data.reports
        return params.data && params.data.reports ? params.data.reports.length : "0";
      }
    },
    //   {
    //     headerName: "Dashboards",
    //     field: "dashboards",
    //     cellClass: "clickable-cell",
    //     enableRowGroup: true,
    //     filter: true,
    //     width: "200",
    //     valueGetter: (params) =>{
    //       return params.data && params.data.dashboards ? params.data.dashboards.length : "0";
    //     }
    //   },
    //   {
    //     headerName: "Ag Reports",
    //     field: "reports_count",
    //     cellClass: "clickable-cell",
    //     filter: true,
    //     enableRowGroup: true,
    //     width: "200",
    //     valueGetter: (params) => {
    //         // This will be updated with the fetched data
    //         return params.data ? params.data.reports_count : "0";
    //     }
    // },
    //   {
    //     headerName: "DA", // New column for 'da'
    //     field: "da",
    //     filter: true,
    //     width: "200",
    //     enableRowGroup: true,
    //     cellClass: "clickable-cell",
    //     valueGetter: (params) => {
    //       return params.data && params.data.da ? params.data.da : "N/A";
    //     }
    //   },
    //   {
    //     headerName: "BA", // New column for 'ba'
    //     field: "ba",
    //     filter: true,
    //     width: "200",
    //     enableRowGroup: true,
    //     cellClass: "clickable-cell",
    //     valueGetter: (params) => {
    //       return params.data && params.data.ba ? params.data.ba : "N/A";
    //     }
    //   },
    // {
    //   headerName: "Stakeholder Count", 
    //   field: "stakeholder_count", // This field should match what you're checking in onCellClicked
    //   cellClass: "clickable-cell",
    //   filter: true,
    //   enableRowGroup: true,
    //   width: "200",
    // },

    {
      headerName: 'Visibility',
      field: 'visibility',
      enableRowGroup: true,
      sortable: true,
      filter: 'agSetColumnFilter', // Use built-in set filter
      cellRenderer: params => (
        <input
          type="checkbox"
          checked={params.value === true} // Checkbox checked if visibility is true
          onChange={() => handleVisibilityChange(params.data)} // Call function on change
        />
      ),
      filterParams: {
        values: [true, false, null], // Include null for filtering options
        suppressAndOrCondition: true // Optional: Customize how the filter behaves
      }
    },

    // { field: 'remarks', headerName: 'remarks', editable: true, enableRowGroup: true, }, 
    
    // {
    //   headerName: 'Airline',
    //   field: 'airline',
    //   sortable: true,
    //   filter: 'agSetColumnFilter',
    //   enableRowGroup: true,
    //   cellRenderer: params => (
    //     <input
    //       type="checkbox"
    //       checked={params.value === true}
    //       onChange={(e) => handleAirlineChange(params.data)} // Call function on change
    //     />
    //   ),
    //   filterParams: {
    //     values: [true, false, null], // Include null for filtering options
    //     suppressAndOrCondition: true // Optional: Customize how the filter behaves
    //   }
    // },
    {
      headerName: 'Hotel',
      field: 'hotel',
      sortable: true,
      filter: 'agSetColumnFilter',
      enableRowGroup: true,
      // rowGroup:true,
      cellRenderer: params => (
        <input
          type="checkbox"
          checked={params.value === true}
          onChange={(e) => handleHotelChange(params.data)} // Call function on change
        />
      ),
      filterParams: {
        values: [true, false, null], // Include null for filtering options
        suppressAndOrCondition: true // Optional: Customize how the filter behaves
      },
    },

    //   { 
    //     field: 'meta', 
    //     headerName: 'Meta Data', 
    //     sortable: true, 
    //     filter: true, 
    //     cellRenderer: params => {
    //         if (!params.value) return 'Null';
    //         return `${JSON.stringify(params.value, null, 2)}`; // Display formatted JSON
    //     },
    //     editable: false, // Prevent editing of the meta column
    //     enableRowGroup: true,
    // },  


    // { field: 'followups_as_per', headerName: 'Followups As Per', editable: false, cellClass: "clickable-cell", },

    // ...['invoice', 'einvoice'].map(field => ({
    //     field,
    //     filter: true, 
    //     enableRowGroup: true,
    //     headerName: field.charAt(0).toUpperCase() + field.slice(1),
    //     cellRenderer: params => (
    //         <input
    //             type="checkbox"
    //             checked={params.value === 'YES'}
    //             onChange={e => handleCheckboxChange(params, field, e.target.checked)}
    //         />
    //     ),
    //     editable: false // Boolean columns are controlled via checkboxes, not directly editable
    // })),
  ]);




  // const handleCellValueChange = async (params) => {
  //   const { workspace_id, remarks } = params.data;

  //   try {
  //     const response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/addremark', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         "Authorization": `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({ workspace_id, remarks }),
  //     });

  //     if (!response.ok) {
  //       throw new Error('Failed to update data');
  //     }

  //     console.log('Data updated successfully:', { workspace_id, remarks });
  //   } catch (error) {
  //     console.error('Error updating data:', error);
  //   }
  // };



  const handleCellValueChange = async params => {
    const { workspace_id, meta } = params.data;
    const field = params.colDef.field;
    let newValue = params.value;

    // Skip API call if "Select" is chosen for followups_as_per
    if (field === 'followups_as_per' && newValue === 'Select') {
      return; // Exit early without updating anything
    }

    // Ensure priority is stored as a number
    if (field === 'priority') {
      newValue = Number(newValue);
      if (isNaN(newValue)) {
        alert(`Invalid value for priority: "${params.value}". Please enter a numeric value.`);
        return; // Exit if the value is not a valid number
      }
    }
    const updatedMeta = { ...meta, [field]: newValue };

    const updatedRow = {
      ...params.data,
      [field]: newValue, // Update the current field value
      meta: updatedMeta // Update the meta column
    };

    setRowData(prev =>
      prev.map(row => (row.workspace_id === workspace_id ? updatedRow : row))
    );

    // Call the API only if a valid value is selected
    updateMetaInBackend(workspace_id, updatedMeta);
  };


  const handleCheckboxChange = (params, field, checked) => {
    const updatedValue = checked ? 'YES' : 'NO';

    const updatedRow = {
      ...params.data,
      [field]: updatedValue,
      meta: { ...params.data.meta, [field]: updatedValue } // Update meta in the row
    };

    setRowData(prev =>
      prev.map(row => (row.workspace_id === params.data.workspace_id ? updatedRow : row))
    );

    updateMetaInBackend(params.data.workspace_id, updatedRow.meta);
  };

  const handle23CheckboxChange = (params, field, checked) => {
    const updatedValue = checked ? 'YES' : 'NO';

    const updatedRow = field === 'fy23_followup' ? {
      ...params.data,
      [field]: updatedValue,
      meta: {
        ...params.data.meta,
        fy23: {
          [field]: updatedValue
        }
      }
    } : {
      ...params.data,
      [field]: updatedValue,
      meta: {
        ...params.data.meta,
        fy23: {
          ...params.data.meta.fy23, // Retain existing fy23 values
          [field]: updatedValue     // Append/Update the specific field
        }
      }
    };

    console.log(updatedRow)


    setRowData(prev =>
      prev.map(row => (row.workspace_id === params.data.workspace_id ? updatedRow : row))
    );
    updateMetaInBackend(params.data.workspace_id, updatedRow.meta);
  };

  const handle24CheckboxChange = (params, field, checked) => {
    const updatedValue = checked ? 'YES' : 'NO';

    const updatedRow = field === 'fy24_followup' ? {
      ...params.data,
      [field]: updatedValue,
      meta: {
        ...params.data.meta,
        fy24: {
          [field]: updatedValue
        }
      }
    } : {
      ...params.data,
      [field]: updatedValue,
      meta: {
        ...params.data.meta,
        fy24: {
          ...params.data.meta.fy24,
          [field]: updatedValue
        }
      }
    };

    console.log(updatedRow)

    setRowData(prev =>
      prev.map(row => (row.workspace_id === params.data.workspace_id ? updatedRow : row))
    );
    updateMetaInBackend(params.data.workspace_id, updatedRow.meta);
  };

  const updateMetaInBackend = async (workspace_id, updatedMeta) => {
    try {
      const response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/update-meta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ workspace_id, metaUpdate: updatedMeta })
      });

      if (!response.ok) {
        throw new Error('Failed to update meta');
      }
      alert('Meta updated successfully');
      console.log('Meta updated successfully');
    } catch (error) {
      console.error('Error updating meta:', error);
    }
  };


  const handleHotelFrontendSync = async () => {
    const response = await fetch('https://stage-apiplatform.finkraft.ai/api/meta/hotel/frontend-update',{
      method:'GET'
    });

    if (!response.status == 200) {
      console.log(response)
      throw new Error('Failed to sync to mongo')
    }

    alert ('Sync to Mongo Started Successfully')
    console.log(response)
    console.log('Sync to mongo started')
  };

  const handleVisibilityChange = async (rowData) => {

    // console.log(rowData);
    const savedToken = sessionStorage.getItem('token');


    const newVisibility = !rowData.visibility; // Toggle visibility

    try {
      // Ensure the correct ID is being used
      if (!rowData.workspace_id) {
        throw new Error('Workspace ID is missing');
      }

      // Call API to update visibility in the database
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/updateVisibility/${rowData.workspace_id}`, {
        method: 'PUT', // or 'PATCH' depending on your backend setup
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${savedToken}`,
        },
        body: JSON.stringify({ visibility: newVisibility }),
      });

      if (response.ok) {
        // Update the rowData with new visibility
        setRowData(prevRowData =>
          prevRowData.map(row =>
            row.workspace_id === rowData.workspace_id ? { ...row, visibility: newVisibility } : row
          )
        );

        // Show alert for visibility change
        alert(`Visibility changed to ${newVisibility ? 'true' : 'false'} for ${rowData.workspace_name}`);
      } else {
        throw new Error('Failed to update visibility');
      }
    } catch (error) {
      console.error("Error updating visibility:", error);
      alert("An error occurred while updating visibility.");
    }
  };


  const handleAirlineChange = async (rowData) => {
    // console.log(rowData);
    const savedToken = sessionStorage.getItem('token');

    const newairline = !rowData.airline;

    try {
      // Ensure the correct ID is being used
      if (!rowData.workspace_id) {
        throw new Error('Workspace ID is missing');
      }

      // Call API to update airline in the database
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/updateAirline/${rowData.workspace_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${savedToken}`,
        },
        body: JSON.stringify({ airline: newairline }),
      });

      if (response.ok) {
        // Update the rowData with new airline
        setRowData(prevRowData =>
          prevRowData.map(row =>
            row.workspace_id === rowData.workspace_id ? { ...row, airline: newairline } : row
          )
        );

        alert(`Airline updated to ${newairline} for ${rowData.workspace_name}`);
      } else {
        throw new Error('Failed to update airline');
      }
    } catch (error) {
      console.error("Error updating airline:", error);
      alert("An error occurred while updating airline.");
    }
  };

  const handleHotelChange = async (rowData) => {
    // console.log(rowData);
    const savedToken = sessionStorage.getItem('token');


    const newhotel = !rowData.hotel;

    try {
      // Ensure the correct ID is being used
      if (!rowData.workspace_id) {
        throw new Error('Workspace ID is missing');
      }

      // Call API to update hotel in the database
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/updateHotel/${rowData.workspace_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${savedToken}`,
        },
        body: JSON.stringify({ hotel: newhotel }),
      });

      if (response.ok) {
        // Update the rowData with new hotel
        setRowData(prevRowData =>
          prevRowData.map(row =>
            row.workspace_id === rowData.workspace_id ? { ...row, hotel: newhotel } : row
          )
        );

        alert(`Hotel updated to ${newhotel} for ${rowData.workspace_name}`);
      } else {
        throw new Error('Failed to update hotel');
      }
    } catch (error) {
      console.error("Error updating hotel:", error);
      alert("An error occurred while updating hotel.");
    }
  };



  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [isBoxFormOpen, setIsBoxFormOpen] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [viewType, setViewType] = useState(""); // 'reports' or 'dashboards'
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    embedurl: "",
    report_name: "",
    report_number: "",
    box_folder_id: "",
  });
  const [editingItem, setEditingItem] = useState(null); // For update functionality

  const [userNames, setUserNames] = useState({}); // State to store user names


  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }

    const fetchWorkspaces = async () => {
      try {
        // Fetch workspace data
        const workspaceResponse = await fetch("https://apiplatform.finkraft.ai/meta/workspaces");
        const workspaceData = await workspaceResponse.json();

        // Create a mapping for agent names from the workspace data
        const agencyNameMap = {};
        workspaceData.forEach(workspace => {
          agencyNameMap[workspace.id] = workspace.name; // Map workspace ID to agency name
        });

        setAgencyNameMap(agencyNameMap);

        // Fetch report data
        const reportResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/report/reports");
        const reportData = await reportResponse.json();

        // Fetch GSTIN counts
        const gstinResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/meta/totalgstins");
        const gstinData = await gstinResponse.json();

        // Fetch PAN counts
        const panResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/meta/panscount");
        const panData = await panResponse.json();

        // Fetch stakeholder counts
        const stakeholderCountResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/meta/stakeholderscount");
        const stakeholderCounts = await stakeholderCountResponse.json();

        // Create a mapping for GSTIN counts
        const gstinCountMap = {};
        gstinData.data.forEach(item => {
          gstinCountMap[item.workspace_name] = item.total_gstin_count;
        });



        // Create a mapping for PAN counts
        const panCountMap = {};
        panData.forEach(item => {
          panCountMap[item.workspace_id] = item.pancount;
        });

        // Create a mapping for stakeholder counts
        const stakeholderCountMap = {};
        stakeholderCounts.data.forEach(item => {
          stakeholderCountMap[item.workspace_id] = item.stakeholderscount;
        });

        // Create a mapping for DA and BA names
        const daNames = {};
        const baNames = {};

        // Fetch names for DA and BA IDs
        const daIds = [...new Set(workspaceData.map(ws => ws.da).filter(id => id))]; // Unique DA IDs
        const baIds = [...new Set(workspaceData.map(ws => ws.ba).filter(id => id))]; // Unique BA IDs


        const fetchNames = async (ids, map) => {
          await Promise.all(ids.map(async (id) => {
            const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/users/${id}`);
            const userData = await response.json();
            map[id] = userData.data.name; // Map ID to name
          }));
        };

        await Promise.all([
          fetchNames(daIds, daNames),
          fetchNames(baIds, baNames)
        ]);

        const reportsResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/meta/workspace-reports-count");
        const reportsData = await reportsResponse.json();

        // Create a mapping for reports count
        const reportsCountMap = {};
        reportsData.forEach(item => {
          reportsCountMap[item.workspace_id] = item.reports_count; // Map workspace_id to reports_count
        });


        // Fetch counts for each workspace and map the results
        const updatedData = await Promise.all(
          workspaceData.map(async (workspace) => {
            // Find the report by matching workspace_id
            const report = reportData.find((r) => r.workspace_id === workspace.id);

            // Initialize box_folder_id and other counts
            const boxFolderId = report ? report.box_folder_id : "null";
            const gstinCount = gstinCountMap[workspace.name] || "0"; // Get GSTIN count from map
            const panCount = panCountMap[workspace.id] || "0"; // Get PAN count from map
            const stakeholderCount = stakeholderCountMap[workspace.id] || 0; // Get stakeholder count from map
            const agencyName = agencyNameMap[workspace.agency_name] || "null";
            const daName = daNames[workspace.da] || "null"; // Get DA name from map
            const baName = baNames[workspace.ba] || "null"; // Get BA name from map


            return {
              workspace_id: workspace.id, // Show workspace_id
              workspace_name: workspace.name, // Show workspace name
              is_active: workspace.is_active, // Show is_active
              workspace_box_id: workspace.box_folder_id || "null", // Show workspace_box_id
              reports: report ? report.reports : [], // Map report data if available
              dashboards: report ? report.dashboards : [], // Map dashboard data if available
              gstin_count: gstinCount, // Add the count of GSTINs
              pan_count: panCount, // Add the count of PANs
              box_folder_id: boxFolderId, // Add the box_folder_id from report
              da: daName, // Use DA name
              ba: baName, // Use BA name
              stakeholder_count: stakeholderCount, // Add the stakeholder count
              visibility: workspace.visibility, // Add visibility field
              remarks: workspace.remark,
              agency_name: agencyName,// Use mapped agency name
              airline: workspace.airline,
              hotel: workspace.hotel,
              entity_type: workspace.entity_type,
              reports_count: reportsCountMap[workspace.id] || 0,
              meta: workspace.meta,
              fy24_followup: workspace.meta?.fy24?.fy24_followup || 'NO',
              fy23_followup: workspace.meta?.fy23?.fy23_followup || 'NO',
              fy24_booking: workspace.meta?.fy24?.fy24_booking || 'NO',
              fy23_booking: workspace.meta?.fy23?.fy23_booking || 'NO',
              fy24_expense: workspace.meta?.fy24?.fy24_expense || 'NO',
              fy23_expense: workspace.meta?.fy23?.fy23_expense || 'NO',
              fy24_2b: workspace.meta?.fy24?.fy24_2b || 'NO',
              fy23_2b: workspace.meta?.fy23?.fy23_2b || 'NO',
              // booking: workspace.meta?.booking || 'NO',
              // expense: workspace.meta?.expense || 'NO',
              // invoice: workspace.meta?.invoice || 'NO',
              // ['2b']: workspace.meta?.['2b'] || 'NO',
              einvoice: workspace.meta?.einvoice || 'NO',
              priority: workspace.meta?.priority || '',
              commercials: workspace.meta?.commercials || '',
              followups_as_per: workspace.meta?.followups_as_per || ''
            };
          })
        );

        // Update the state with the modified data
        setRowData(updatedData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchWorkspaces();
  }, []);

  const [showPopup, setShowPopup] = useState(false); // To control popup visibility
  const [selectedRow, setSelectedRow] = useState(null); // To store the row data for selected cell
  const [panData, setPanData] = useState([]);
  const [existingName, setExistingName] = useState("");
  const [existingIsActive, setExistingIsActive] = useState(false);
  const [isGstinModalOpen, setIsGstinModalOpen] = useState(false);
  const [isStakeholdersModalOpen, setIsStakeholdersModalOpen] = useState(false);
  const [isAgreportsModalOpen, setIsAgreportsModalOpen] = useState(false);


  useEffect(() => {
    if (isPanModalOpen && selectedWorkspace) {
      fetch(
        `https://apiplatform.finkraft.ai/meta/pans/${selectedWorkspace.workspace_id}`
      )
        .then((response) => response.json())
        .then((data) => {
          setPanData(data); // Assuming data is an array of PAN objects
        })
        .catch((error) => {
          console.error("Error fetching PAN data:", error);
        });
    }
  }, [isPanModalOpen, selectedWorkspace]);

  const onCellClicked = (params) => {
    if (params.colDef.field === "pan_count") {
      setSelectedWorkspaceId(params.data.workspace_id);
      setPanCount(params.data.pan_count);
      setExistingName(params.data.workspace_name);
      setExistingIsActive(params.data.is_active);
      setBoxfolderid(params.data.workspace_box_id)
      setWorkspaceName(params.data.workspace_name)
      setIsPanModalOpen(true); // Open the PAN modal
    }
    else if (params.colDef.field === 'followups_as_per') {
      openPopup(params); // Open popup when cell is clicked in the followups_as_per column
    }
    else if (params.colDef.field === "gstin_count") {
      setSelectedWorkspaceId(params.data.workspace_id);
      setWorkspaceName(params.data.workspace_name)
      setIsGstinModalOpen(true); // Open the GSTIN modal
    }
    else if (params.colDef.field === "box_folder_id") {
      setSelectedWorkspace(params.data);
      setWorkspaceName(params.data.workspace_name)
      setFormData({ box_folder_id: params.data.box_folder_id });
      setIsBoxFormOpen(true);
    }
    else if (params.colDef.field === "da") {
      setSelectedWorkspaceId(params.data.workspace_id);
      setWorkspaceName(params.data.workspace_name)
      setSelectedDaValue(params.data.da); // Get current DA value
      setIsDaModalOpen(true); // Open the DA modal
    } else if (params.colDef.field === "ba") {
      setSelectedWorkspaceId(params.data.workspace_id);
      setWorkspaceName(params.data.workspace_name)
      setSelectedBaValue(params.data.ba); // Get current BA value
      setIsBaModalOpen(true); // Open the BA modal
    }
    else if (params.colDef.field === "stakeholder_count") { // Make sure to add this to your columnDefs
      console.log("Cell clicked:", params);
      setSelectedWorkspaceId(params.data.workspace_id);
      setWorkspaceName(params.data.workspace_name)
      setIsStakeholdersModalOpen(true); // Open the stakeholders modal
    }
    else if (params.colDef.field === "reports_count") {
      setSelectedWorkspaceId(params.data.workspace_id);
      setWorkspaceName(params.data.workspace_name)
      setIsAgreportsModalOpen(true); // Open the Agreports modal
    }
    else if (params.colDef.field === "box_folder_id") {
      const boxFolderId = params.data.box_folder_id; // Get the box_folder_id
      const url = `/boxfolderid.html?box_folder_id=${boxFolderId}`; // Construct URL with query parameter
      window.location.href = url; // Redirect to the URL
    }
    else if (params.colDef.field === "workspace_box_id") {
      console.log("Cell clicked:", params);
      setBoxFolderId(params.data.workspace_box_id); // Set the box folder ID
      setIsModalVisible(true); // Open the modal
    }
    else if (params.colDef.field === "agency_name") {
      setSelectedWorkspaceId(params.data.workspace_id); // Capture workspace ID
      setIsWorkspaceModalOpen(true); // Open the modal for workspace selection
    }
    else if (
      params.colDef.field === "reports" ||
      params.colDef.field === "dashboards"
    ) {
      const dataWithBoxFolderId = params.data[params.colDef.field].map(
        (item) => ({
          ...item,
        })
      );

      setModalData(dataWithBoxFolderId);
      setViewType(params.colDef.field);
      setSelectedWorkspace(params.data);
      setWorkspaceName(params.data.workspace_name)
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedWorkspace(null);
    setViewType("");
    setEditingItem(null); // Reset editing item when closing modal
  };

  const openForm = (item) => {
    setFormData(item);
    setEditingItem(item);
    setIsFormOpen(true);
  };

  const closeModalHandler = () => {
    setIsModalVisible(false); // Close the modal
    setBoxFolderId(''); // Reset the box folder ID
  };

  const closeForm = () => {
    setIsFormOpen(false);
    setIsBoxFormOpen(false);
    setFormData({
      embedurl: "",
      report_name: "",
      report_number: "",
      box_folder_id: "",
    });
    setEditingItem(null); // Clear editing item when closing form
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    const endpoint = viewType === "reports" ? "/addReport" : "/addDashboard";

    try {
      const response = await fetch(
        `https://stage-apiplatform.finkraft.ai/api/report${endpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...formData,
            workspace_id: selectedWorkspace.workspace_id,
          }),
        }
      );

      if (response.ok) {
        const newItem = await response.json();

        // Update the modal data with the new report/dashboard
        setModalData((prevData) => [...prevData, newItem]);

        // Update the corresponding row in rowData
        setRowData((prevRowData) =>
          prevRowData.map((row) =>
            row.workspace_id === selectedWorkspace.workspace_id
              ? {
                ...row,
                [viewType]: [...row[viewType], newItem], // Update the count for reports/dashboards
              }
              : row
          )
        );
        closeForm();
      } else {
        console.error("Failed to add item");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const endpoint =
      viewType === "reports" ? "/updateReport" : "/updateDashboard";
    const body = {
      ...formData,
      workspace_id: selectedWorkspace.workspace_id,
      old_embedurl: editingItem.embedurl, // Send old embedurl to identify the item to be updated
    };

    try {
      const response = await fetch(
        `https://stage-apiplatform.finkraft.ai/api/report${endpoint}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        }
      );

      if (response.ok) {
        const updatedItem = await response.json();

        // Update the modal data with the updated item
        setModalData((prevData) =>
          prevData.map((item) =>
            item.embedurl === editingItem.embedurl ? updatedItem : item
          )
        );

        // Update the corresponding row in rowData
        setRowData((prevRowData) =>
          prevRowData.map((row) =>
            row.workspace_id === selectedWorkspace.workspace_id
              ? {
                ...row,
                [viewType]: row[viewType].map((item) =>
                  item.embedurl === editingItem.embedurl ? updatedItem : item
                ),
              }
              : row
          )
        );
        closeForm();
      } else {
        console.error("Failed to update item");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const handleDelete = async (data) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );

    if (confirmDelete) {
      const endpoint =
        viewType === "reports" ? "/deleteReport" : "/deleteDashboard";

      try {
        const response = await fetch(
          `https://stage-apiplatform.finkraft.ai/api/report${endpoint}`,
          {
            method: "DELETE",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            body: JSON.stringify({
              workspace_id: selectedWorkspace.workspace_id,
              embedurl: data.embedurl,
            }),
          }
        );

        if (response.ok) {
          // Remove the deleted item from modal data
          setModalData((prevData) =>
            prevData.filter((item) => item.embedurl !== data.embedurl)
          );

          // Decrease the count in rowData
          setRowData((prevRowData) =>
            prevRowData.map((row) =>
              row.workspace_id === selectedWorkspace.workspace_id
                ? {
                  ...row,
                  [viewType]: row[viewType].filter(
                    (item) => item.embedurl !== data.embedurl
                  ),
                }
                : row
            )
          );
        } else {
          console.error("Failed to delete item:", response.statusText);
        }
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    }
  };


  const handleEditClick = (item) => {
    openForm(item);
  };


  const handleUpdateBoxFolderId = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        `https://stage-apiplatform.finkraft.ai/api/report/updateBoxFolderId`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            workspace_id: selectedWorkspace.workspace_id,
            box_folder_id: formData.box_folder_id,
          }),
        }
      );

      if (response.ok) {
        const responseData = await response.json();

        // Validate the response data
        if (responseData && typeof responseData.box_folder_id === "number") {
          const newBoxFolderId = responseData.box_folder_id;

          // Update the rowData state with the new box_folder_id
          setRowData((prevData) =>
            prevData.map((item) =>
              item.workspace_id === selectedWorkspace.workspace_id
                ? { ...item, box_folder_id: newBoxFolderId }
                : item
            )
          );
          closeForm();
        } else {
          console.error("Invalid response data:", responseData);
        }
      } else {
        console.error("Failed to update box_folder_id");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [isCreateWorkspaceModalOpen, setIsCreateWorkspaceModalOpen] =
    useState(false);

  const handleOpenCreateWorkspaceModal = () => {
    setIsCreateWorkspaceModalOpen(true);
  };

  const handleCloseCreateWorkspaceModal = () => {
    setIsCreateWorkspaceModalOpen(false);
  };

  const handleWorkspaceSubmit = (formData) => {
    console.log(formData);

    // Close the modal
    setIsCreateWorkspaceModalOpen(false);

    // Construct the new workspace object
    const newWorkspace = {
      name: formData.name,
      is_active: formData.is_active,
      workspace_box_id: formData.box_folder_id,
    };

    // Update rowData with the new workspace
    setRowData((prevRowData) => [...prevRowData, newWorkspace]);
  };

  const modalColumns = [
    { headerName: "Embed URL", field: "embedurl", enableRowGroup: true, sortable: true, },
    {
      headerName: viewType === "reports" ? "Report Name" : "Dashboard Name",
      field: "report_name", enableRowGroup: true, sortable: true,
    },
    {
      headerName: viewType === "reports" ? "Report Number" : "Dashboard Number",
      field: "report_number", enableRowGroup: true, sortable: true,
    },
    {
      headerName: "Actions", enableRowGroup: true, sortable: true,
      cellRenderer: (params) => (
        <div>
          <button
            className="edit-button"
            onClick={() => handleEditClick(params.data)}
          >
            Edit
          </button>
          <button
            className="delete-button"
            onClick={() => handleDelete(params.data)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  // Function to fetch the latest PAN counts for all workspaces
  const fetchPanCounts = async () => {
    try {
      const panResponse = await fetch("https://stage-apiplatform.finkraft.ai/api/meta/panscount");
      const panData = await panResponse.json();

      // Create a mapping of workspace_id to pan_count
      const panCountMap = {};
      panData.forEach(item => {
        panCountMap[item.workspace_id] = item.pancount;
      });

      // Update the rowData with the new PAN counts
      setRowData((prevRowData) =>
        prevRowData.map((row) => ({
          ...row,
          pan_count: panCountMap[row.workspace_id] || "0", // Use the new PAN count or default to "0"
        }))
      );
    } catch (error) {
      console.error("Error fetching PAN counts:", error);
    }
  };


  // const handlePanModalUpdate = async () => {
  //   // Fetch and update PAN counts for all workspaces
  //   await fetchPanCounts();
  // };

  const handlePanModalUpdate = (updatedRow) => {
    setRowData(prevRowData =>
      prevRowData.map(row =>
        row.workspace_id === updatedRow.workspace_id ? { ...row, ...updatedRow } : row
      )
    );
    fetchPanCounts();
  };

  const handleBaSave = async (userId) => {
    try {
      // Fetch the user name using userId
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/users/${userId}`);
      const userData = await response.json();

      // Update rowData with the fetched name
      setRowData(prevData =>
        prevData.map(item => {
          if (item.workspace_id === selectedWorkspaceId) {
            return { ...item, ba: userData.data.name }; // Update BA value in the row data with name
          }
          return item;
        })
      );

      setIsBaModalOpen(false); // Close modal after saving
    } catch (error) {
      console.error("Error fetching user name:", error);
    }
  };

  const handleDaSave = async (userId) => {
    try {
      // Fetch the user name using userId
      const response = await fetch(`https://stage-apiplatform.finkraft.ai/api/meta/users/${userId}`);
      const userData = await response.json();

      // Update rowData with the fetched name
      setRowData(prevData =>
        prevData.map(item => {
          if (item.workspace_id === selectedWorkspaceId) {
            return { ...item, da: userData.data.name }; // Update DA value in the row data with name
          }
          return item;
        })
      );

      setIsDaModalOpen(false); // Close modal after saving
    } catch (error) {
      console.error("Error fetching user name:", error);
    }
  };


  const handleCloseModal = () => {
    setIsStakeholdersModalOpen(false);
    setSelectedWorkspaceId(null);
  };

  const updateStakeholderCount = (workspaceId, newCount) => {
    setRowData((prevRowData) =>
      prevRowData.map((workspace) =>
        workspace.workspace_id === workspaceId
          ? { ...workspace, stakeholder_count: newCount }
          : workspace
      )
    );
  };

  const [isWorkspaceModalOpen, setIsWorkspaceModalOpen] = useState(false);



  const handleSave = ({ agentId, workspaceId }) => {
    console.log("agentId:", agentId, "workspaceId:", workspaceId);

    // Find the agency name based on the agentId
    const agencyName = agencyNameMap[agentId] || "Unknown"; // Replace with "Unknown" if no match is found

    setRowData((prevData) => {
      const updatedData = prevData.map((row) =>
        row.workspace_id === workspaceId ? { ...row, agency_name: agencyName } : row
      );

      console.log("Updated Row Data:", updatedData); // Log updated data
      return updatedData;
    });
  };


  const closeAgreportsModal = () => {
    setIsAgreportsModalOpen(false);
  };


  const openPopup = (params) => {
    setSelectedRow(params.data);
    setShowPopup(true); // Show the popup when a cell is clicked
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRow(null); // Clear selected row data
  };

  const handlePopupSubmit = async (selectedValue) => {
    if (selectedRow) {
      // Update the followups_as_per field in the selected row
      const updatedMeta = { ...selectedRow.meta, followups_as_per: selectedValue };
      const updatedRow = { ...selectedRow, meta: updatedMeta, followups_as_per: selectedValue };

      console.log(updatedRow)

      // Update the state to reflect the changes in the table
      setRowData(prev =>
        prev.map(row => (row.workspace_id === selectedRow.workspace_id ? updatedRow : row))
      );

      // Update the backend with the new value
      updateMetaInBackend(selectedRow.workspace_id, updatedMeta);

      // Close the popup
      closePopup();
    }
  };






  return (
    <div>
      <button
        className="add-workspace-button"
        onClick={handleOpenCreateWorkspaceModal}
      >
        Add Workspace
      </button>
      <Link to="/addgstin">
        <button className="add-workspace-button">ADD GSTIN</button>
      </Link>
      {/* <Link to ='https://stage-apiplatform.finkraft.ai/api/meta/hotel/frontend-update'> */}
      <button 
        className="add-workspace-button"
        onClick={handleHotelFrontendSync}
      > 
        Sync Hotel Frontend
      </button>
      <div className="ag-theme-alpine" style={{ height: '100vh', width: '100%' }}>
        <AgGridReact
          // rowData={rowData}
          columnDefs={columnDefs}
          onCellValueChanged={handleCellValueChange}
          onCellClicked={onCellClicked}
          defaultColDef={{ filter: true }}
          rowGroupPanelShow='always'
          groupable="true"
          rowData={filteredData}

        />
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Reports/Dashboards Modal"
        className="custom-modal-report"
      >
        <h2>
          {viewType === "reports"
            ? `Report for Workspace : ${workspaceName}`
            : `Dashboard for Workspace : ${workspaceName}`}
        </h2>
        <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
          <AgGridReact rowData={modalData} columnDefs={modalColumns} />
        </div>
        <div className="form-buttons">
          <button className="modal-button" onClick={() => setIsFormOpen(true)}>
            Add
          </button>
          <button className="modal-button" onClick={closeModal}>
            Close
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={isBoxFormOpen}
        onRequestClose={closeForm}
        contentLabel="Add/Edit Box Folder ID"
        className="custom-form-modal-report"
      >
        <h5>{`Update Box Folder ID for Workspace: ${workspaceName}`}</h5>
        <form onSubmit={handleUpdateBoxFolderId} className="report-form">
          <label className="report-label">Box Folder ID:</label>
          <input
            className="report-input"
            type="text"
            name="box_folder_id"
            value={formData.box_folder_id}
            onChange={handleInputChange}
            required
          />

          <div className="report-buttons">
            <button type="submit">Update</button>
            <button type="button" onClick={closeForm}>
              Cancel
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        contentLabel="Add/Edit Form"
        className="custom-form-modal-report"
      >
        <h2>{editingItem ? "Edit Item" : "Add Item"}</h2>
        <form
          onSubmit={editingItem ? handleUpdate : handleAdd}
          className="report-form"
        >
          <label className="report-label">Embed URL:</label>
          <input
            className="report-input"
            type="text"
            name="embedurl"
            value={formData.embedurl}
            onChange={handleInputChange}
            required
          />

          <label className="report-label">
            {viewType === "reports" ? "Report Name:" : "Dashboard Name:"}
          </label>
          <input
            className="report-input"
            type="text"
            name="report_name"
            value={formData.report_name}
            onChange={handleInputChange}
            required
          />

          <label className="report-label">
            {viewType === "reports" ? "Report Number:" : "Dashboard Number:"}
          </label>
          <input
            className="report-input"
            type="text"
            name="report_number"
            value={formData.report_number}
            onChange={handleInputChange}
            required
          />

          <div className="report-buttons">
            <button type="submit">{editingItem ? "Update" : "Add"}</button>
            <button type="button" onClick={closeForm}>
              Cancel
            </button>{" "}
            {/* Cancel button */}
          </div>
        </form>
      </Modal>
      <PanModal
        isOpen={isPanModalOpen}
        onRequestClose={() => setIsPanModalOpen(false)}
        workspaceId={selectedWorkspaceId}
        existingName={existingName} // Pass the existing name
        existingIsActive={existingIsActive} // Pass the existing active status
        existingBoxFolderId={existingBoxFolderId}
        workspaceName={workspaceName}
        onUpdate={handlePanModalUpdate} // Pass the update function to PanModal
      />
      <CreateWorkspaceModal
        isOpen={isCreateWorkspaceModalOpen}
        onClose={handleCloseCreateWorkspaceModal}
        onSubmit={handleWorkspaceSubmit}
      />
      <GstinModel
        isOpen={isGstinModalOpen}
        onClose={() => setIsGstinModalOpen(false)}
        workspaceId={selectedWorkspaceId}
        workspaceName={workspaceName}
      />
      <DaModal
        show={isDaModalOpen}
        handleClose={() => setIsDaModalOpen(false)}
        selectedWorkspaceId={selectedWorkspaceId}
        daValue={selectedDaValue}
        daName={userNames[selectedDaValue]} // Pass the name
        workspaceName={workspaceName}
        onSave={handleDaSave}
      />

      {isAgreportsModalOpen && (
        <div className="report-modal">
          <Agreports workspaceId={selectedWorkspaceId} onClose={closeAgreportsModal} />
        </div>
      )}

      <BaModal
        show={isBaModalOpen}
        handleClose={() => setIsBaModalOpen(false)}
        selectedWorkspaceId={selectedWorkspaceId}
        baValue={selectedBaValue}
        baName={userNames[selectedBaValue]} // Pass the name
        workspaceName={workspaceName}
        onSave={handleBaSave}
      />

      <StakeholdersModal
        visible={isStakeholdersModalOpen}
        onClose={handleCloseModal}
        workspaceName={workspaceName}
        workspaceId={selectedWorkspaceId}
        onStakeholderCountUpdate={(newCount) =>
          updateStakeholderCount(selectedWorkspaceId, newCount)
        }
      />
      <WorkspaceModal
        isOpen={isWorkspaceModalOpen}
        onClose={() => setIsWorkspaceModalOpen(false)}
        selectedWorkspaceId={selectedWorkspaceId}
        onSave={handleSave}
      />
      <BoxFolderModal isOpen={isModalVisible} onClose={closeModalHandler} boxFolderId={boxFolderId} />
      <PopupModal
        isOpen={showPopup}
        onClose={closePopup}
        onSubmit={handlePopupSubmit}
        value={selectedRow?.followups_as_per}
      />
    </div>
  );
};


export default ReportTable;
